import { render, staticRenderFns } from "./RiskView.vue?vue&type=template&id=c3f58a04"
import script from "./RiskView.vue?vue&type=script&lang=js"
export * from "./RiskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports